import React from "react";
import AdminLayout from "hoc/AdminLayout";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import { useSelector } from "react-redux";
import Customers from "./Customers/Customers";
import Users from "./Users/Users";
import Properties from "./Properties/Properties";
import Olgo from "./Olgo/Olgo";
import Settings from "./Settings/Settings";
import Projects from "./Projects/Projects";
import Profile from "./Profile/Profile";
import HomePage from "./HomePage/HomePage";
import Payment from "./Payment/Payment";
import UserIncrease from "./Payment/UserIncrease";
import Pricing from "./Payment/Pricing";
import Notifications from "./Notifications/Notifications";
import ExtensionPeriod from "./Payment/ExtensionPeriod";
import InformationPanel from "./Payment/InformationPanel";
import Wallet from "./Payment/Wallet";
import Callback from "./Payment/Callback";
import Histories from "./Payment/History/Histories";
import HistoriesDetails from "./Payment/History/components/HistoriesDetails";
import SupportIndex from "./Support/SupportIndex";

function Dashboard(props) {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  return (
    <AdminLayout {...props}>
      <Switch>
        <Redirect exact from="/dashboard" to="/dashboard/home" />
        <Redirect
          exact
          from="/dashboard/invoices"
          to="/dashboard/projects/invoices"
        />
        <Redirect
          exact
          from="/dashboard/construction"
          to="/dashboard/projects/construction"
        />
        <Redirect
          exact
          from="/dashboard/contract"
          to="/dashboard/projects/contract"
        />
        <Redirect
          exact
          from="/dashboard/profit"
          to="/dashboard/projects/profit"
        />
        <PrivateRoute
          path="/dashboard/home"
          component={HomePage}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/projects"
          component={Projects}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/properties"
          component={Properties}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/customers"
          component={Customers}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/users"
          component={Users}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/patterns"
          component={Olgo}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/settings"
          component={Settings}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/profile"
          component={Profile}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/support"
          component={SupportIndex}
          isLoggedIn={isLoggedIn}
        />
        {/* <PrivateRoute //todo
          path="/dashboard/statistics"
          component={Statistics}
          isLoggedIn={isLoggedIn}
        /> */}
        <PrivateRoute
          exact
          path="/dashboard/payment"
          component={Payment}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/user-increase"
          component={UserIncrease}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/pricing"
          component={Pricing}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/notifications"
          component={Notifications}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/extension-period"
          component={ExtensionPeriod}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/information-panel"
          component={InformationPanel}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/wallet"
          component={Wallet}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/callback"
          component={Callback}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          exact
          path="/dashboard/payment/histories"
          component={Histories}
          isLoggedIn={isLoggedIn}
        />
        <PrivateRoute
          path="/dashboard/payment/histories/:id"
          component={HistoriesDetails}
          isLoggedIn={isLoggedIn}
        />
        <Redirect exact from="*" to="/dashboard/home" />
      </Switch>
    </AdminLayout>
  );
}

export default Dashboard;
